module.exports = __webpack_public_path__ + "static/media/pain-m.54fd87b8.svg";